import React from "react";
import ReactDOM from "react-dom/client";
import "./";
import "./index.css";
import App from "./App";
// import "./assets/fonts";
import { BrowserRouter } from "react-router-dom";
import { AppProvider } from "./context/Appcontext";
import "./assets/css/general/globalCSS/global.css";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProvider>
  </React.StrictMode>,
);

reportWebVitals();
